<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-buttons slot="start">
      <ion-button *ngIf="view === 'manual' || view ==='summary'"
                  mode="md"
                  color="orange"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
        {{'common.back' | transloco}}
      </ion-button>
    </ion-buttons>
    <ion-title>{{'pos.giftCard' | transloco}}</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">{{'common.close' | transloco}}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="gift-card-payment-modal">
    <div class="gift-card-payment-modal__scan"
         *ngIf="view === 'scan'">
      <ion-toolbar color="orange">
        <ion-title>{{ 'payment.scanOrSwipeGiftCard' | transloco }}</ion-title>
      </ion-toolbar>
      <div>
        <div>
          <img src="assets/icon/gift_card_scan.svg">
          <label>{{ 'payment.scan' | transloco }}</label>
        </div>
        <label>{{ 'common.or' | transloco | lowercase }}</label>
        <div>
          <img src="assets/icon/gift_card_swipe.svg">
          <label>{{ 'payment.swipe' | transloco }}</label>
        </div>
      </div>
    </div>
    <div class="gift-card-payment-modal__manual"
         *ngIf="view === 'manual'">
      <ion-toolbar color="orange">
        <ion-title>{{ 'payment.enterGiftCardNumber' | transloco }}</ion-title>
      </ion-toolbar>
      <div>
        <ion-input type="text"
                   [placeholder]="'payment.giftCardNumber' | transloco"
                   [(ngModel)]="identification_number"></ion-input>
      </div>
    </div>
    <div class="gift-card-payment-modal__secure"
         *ngIf="view === 'secure'">
      <ion-toolbar color="orange">
        <ion-title>{{ 'payment.enterSecureCode' | transloco }}</ion-title>
      </ion-toolbar>
      <div>
        <p *ngIf="errorMessage">{{errorMessage}}</p>
        <ion-input type="password"
                   [placeholder]="'payment.secureCode' | transloco"
                   [(ngModel)]="secure_code"></ion-input>
      </div>
    </div>
    <div class="gift-card-payment-modal__summary"
         *ngIf="view === 'summary'">
      <ion-toolbar color="orange">
        <ion-title>{{ 'payment.giftCardInformation' | transloco }}</ion-title>
      </ion-toolbar>
      <div>
        <ng-container *ngIf="giftCard; else giftCardNotFoundView">
          <ng-container *ngIf="!isValidGiftCard; else giftCardInformation">
            <p>{{ 'payment.giftCardHasExpired' | transloco }}</p>
            <p *ngIf="this.giftCard.expiry_date">{{ 'payment.expiryDate' | transloco }}: <b>{{ this.giftCard.expiry_date
                | translocoDate }}</b></p>
            <p>{{ 'payment.balance' | transloco }}: <b>{{ giftCard.balance | currency }}</b></p>
          </ng-container>

          <ng-template #giftCardInformation>
            <p class="giftcard-info">{{ 'payment.giftCardBalanceIs' | transloco }} <b>{{ giftCard.balance | currency
                }}</b></p>
          </ng-template>
        </ng-container>
        <ng-template #giftCardNotFoundView>
          <h1>{{ 'payment.giftCardNotFound' | transloco }}</h1>
          <p *ngIf="isPayment">{{ 'payment.tryAgainOrSelectDifferentMethod' | transloco }}</p>
          <p *ngIf="!isPayment">{{ 'payment.pleaseTryAgain' | transloco }}</p>
        </ng-template>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="end">
      <ng-container [ngSwitch]="view">
        <ion-button *ngSwitchCase="GiftCardPaymentModalView.SCAN"
                    color="dark"
                    fill="solid"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onManualEntry()">
          {{ 'payment.manualGiftCardEntry' | transloco }}
        </ion-button>

        <ion-button *ngSwitchCase="GiftCardPaymentModalView.MANUAL"
                    color="dark"
                    fill="solid"
                    [disabled]="!identification_number"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onConfirmManualEntry()">
          {{ 'payment.confirmGiftCardNumber' | transloco }}
        </ion-button>

        <ion-button *ngSwitchCase="GiftCardPaymentModalView.SECURE"
                    color="dark"
                    fill="solid"
                    [disabled]="!secure_code"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onConfirmSecureCode()">
          {{ 'payment.confirmSecureCode' | transloco }}
        </ion-button>

        <ng-container *ngSwitchCase="GiftCardPaymentModalView.SUMMARY">
          <ion-button *ngIf="isPayment"
                      color="dark"
                      fill="solid"
                      [disabled]="!isValidGiftCard"
                      debounce-click
                      [debounceTime]="0"
                      (debounceClick)="onConfirmGiftCard()">
            {{ 'payment.confirmGiftCard' | transloco }}
          </ion-button>
        </ng-container>
      </ng-container>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>